"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";
import styled from "styled-components";

import { SVGIcon } from "../../SVGIcon";

type Direction = "up" | "down" | "left" | "right";

const DirectionalIcon = styled(SVGIcon)<{ direction: Direction }>`
  transform: rotateZ(
    ${({ direction }) => {
      switch (direction) {
        case "right":
          return "90deg";
        case "down":
          return "180deg";
        case "left":
          return "270deg";
        case "up":
        default:
          return "0deg";
      }
    }}
  );
`;

export const Chevron = React.memo(
  ({
    direction,
    className,
    ...props
  }: SVGIcon.IProps & {
    direction: Direction;
  } & React.RefAttributes<SVGElement>) => {
    return (
      <DirectionalIcon
        direction={direction}
        viewBox="0 0 12 7"
        fill="none"
        className={legacyIconCls(className)}
        {...props}
      >
        <path stroke="currentColor" d="M1 6.00005L6 0.994751L11 6.00005" />
      </DirectionalIcon>
    );
  }
);

if (process.env.NODE_ENV !== "production") {
  Chevron.displayName = `ChevronIcon`;
}

export const ChevronUp = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Chevron direction="up" {...props} />;
  }
);

export const ChevronDown = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Chevron direction="down" {...props} />;
  }
);

export const ChevronLeft = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Chevron direction="left" {...props} />;
  }
);

export const ChevronRight = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Chevron direction="right" {...props} />;
  }
);
